import React, { Component } from "react"
import PorfolioBlock from "../components/PortfolioBlock"
import Row from "../components/Row"
import Container from "../components/Container"
import ExperienceBlock from "../components/ExperienceBlock"
import SchoolBlock from "../components/SchoolBlock"
import Experiences from "../data/Experience"
import School from "../data/School"
import Badge from "../components/Badge"
import certificates from "../data/certifications"
import Projects from "../data/Projects"

const resumeDownload = "assets/downloads/Daniel Vasquez - Cybersecurity Professional.pdf"
class Error extends Component {
    render() {
    return (
    <main className="page cv-page">
    <PorfolioBlock>
        <p>Hello! I am <strong>Daniel Vasquez</strong>. <br/> Cybersecurity Analyst specializing in threat detection, vulnerability assessment, and incident response, with industry certifications including PenTest+, CySA+, Security+, and SSCP. Experienced in performing network traffic analysis, forensic investigations, and security risk assessments using tools such as Wireshark, Nmap, Autopsy, Linux, and Python automation. Combines technical security expertise with over five years of operational leadership to improve monitoring visibility, reduce risk exposure, and implement security-focused controls across enterprise environments. Core tools include Wireshark, Nmap, Autopsy, Linux, and Python.</p>

        <div className="text-center"><a data-bs-hover-animate="pulse" className="btn btn-secondary" href={resumeDownload}>Download my Resume</a>
        </div>
    </PorfolioBlock>
        <section className="portfolio-block cv">
            <Container>
                

                <div className="social-icons group">
                    <h2>Certifications</h2>
                    <hr />
                    {certificates.map((badge, index) => (
                        <Badge key={index} {...badge} />
                    ))}
                </div>
                <div data-aos="fade" className="work-experience group">
                    <div className="heading">
                        <h2 className="text-center">Work Experience</h2>
                    </div>
                    {Experiences === undefined ? (
                        <p></p>
                        ) : (
                        Experiences.map(experience => {
                            return (
                            <ExperienceBlock props={experience} />
                            )
                        })
                    )}
                </div>
                <div data-aos="fade" className="education group">
                    <div className="heading">
                        <h2 className="text-center">Education</h2>
                    </div>
                    {School === undefined ? (
                        <p></p>
                        ) : (
                            School.map(experience => {
                            return (
                            <SchoolBlock props={experience} />
                            )
                        })
                    )}
                </div>
                <div data-aos="fade" className="projects group">
                    <div className="heading">
                        <h2 className="text-center">Projects</h2>
                    </div>
                    {Projects === undefined ? (
                        <p></p>
                        ) : (
                            Projects.map(experience => {
                            return (
                            <ExperienceBlock props={experience} />
                            )
                        })
                    )}
                </div>
                <div className="text-center"><a data-bs-hover-animate="pulse" className="btn btn-secondary" href={resumeDownload}>Download my Resume</a>
                    <hr />
                </div>
                <div className="contact-info portfolio-info-card">
                    <h2>Contact Info</h2>
                    <Row>
                        <div className="col-1"><i className="icon ion-person icon"></i></div>
                        <div className="col-9"><span>Daniel Vasquez</span></div>
                    </Row>
                    {/* <Row>
                        <div className="col-1"><i className="icon ion-ios-telephone icon"></i></div>
                        <div className="col-9"><span>+1 (323) 457-4224</span></div>
                    </Row> */}
                    <Row>
                        <div className="col-1"><i className="icon ion-at icon"></i></div>
                        <div className="col-9"><span>contact@dvas4155.com</span></div>
                    </Row>
                </div>
            </Container>
        </section>
    </main>
    );
}}

export default Error;